export enum GTMEventType {
  PRODUCT_CONFIGURATOR = 'product_configurator',
  GENERATE_COLLECTION_PDF = 'generate_collection_pdf',
  ERROR_EVENT = 'error_event',
  CTA_CLICK = 'cta_click',
}
